import { Button, FieldText, FlexBox } from '@dixa/lib-shared-habla';
import {
  floatingLinkActions,
  submitFloatingLink,
  useFloatingLinkSelectors,
} from 'lib-knowledge-document-structure';
import { getPluginOptions } from 'lib-knowledge-document-structure/plate/common';
import { LinkPlugin } from 'lib-knowledge-document-structure/plate/link';
import { useMyEditorRef } from 'lib-knowledge-document-structure/plateHooks';
import {
  ELEMENT_LINK,
  MyValue,
} from 'lib-knowledge-document-structure/plateTypes';
import { useRef, useState } from 'react';

import s from './editLinkTabs.module.scss';

export const EditURLLinkForm = (): JSX.Element => {
  const editor = useMyEditorRef();
  const { isUrl } = getPluginOptions<LinkPlugin, MyValue>(editor, ELEMENT_LINK);
  const [urlTouched, setUrlTouched] = useState(false);

  const url = useFloatingLinkSelectors().url();
  const text = useFloatingLinkSelectors().text();
  const isUrlValid = isUrl?.(url);

  const textRef = useRef<HTMLInputElement>(null);
  const urlRef = useRef<HTMLInputElement>(null);

  // maybe I need to render in link portal
  return (
    <div>
      <FieldText
        label="Link title"
        className={s['field']}
        input={{
          value: text,
          name: 'pleasedontautofillthis',
          onChange: (e) => floatingLinkActions.text(e?.target.value || ''),
          // @ts-expect-error Habla's typedefs are wrong, it is an InputElement
          ref: textRef,
        }}
      />

      <FieldText
        label="Link URL"
        className={s['field']}
        meta={{
          error:
            urlTouched && !isUrlValid ? 'Please enter a valid url' : undefined,
        }}
        input={{
          value: url,
          name: 'link_url',
          onBlur: () => setUrlTouched(true),
          onChange: (e) => floatingLinkActions.url(e?.target.value || ''),
          // @ts-expect-error Habla's typedefs are wrong, it is an InputElement
          ref: urlRef,
        }}
      />

      <FlexBox justifyContent="end" gap="200">
        <Button variant="secondary" onClick={() => floatingLinkActions.hide()}>
          Cancel
        </Button>

        <Button
          disabled={!isUrlValid}
          onClick={() => submitFloatingLink(editor)}
        >
          Save
        </Button>
      </FlexBox>
    </div>
  );
};
